import { render, staticRenderFns } from "./aboutBrief.vue?vue&type=template&id=67a558c1&scoped=true"
import script from "./aboutBrief.vue?vue&type=script&lang=js"
export * from "./aboutBrief.vue?vue&type=script&lang=js"
import style0 from "./aboutBrief.vue?vue&type=style&index=0&id=67a558c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a558c1",
  null
  
)

export default component.exports